<evc-modal
  id="evc-modal"
  [showReduceButton]="false"
  [showCloseButton]="false"
  width="478px"
  height="300px"
>
  <ng-content modal-content>
    <div class="modal-content">
      <div class="info-container">
        <i class="pi pi-info-circle info"></i>
      </div>
      <div class="center-label main-label">
        {{ props.mainLabel }}
      </div>
      <div class="center-label secondary-label">
        {{ props?.secondaryLabel }}
      </div>
    </div>
  </ng-content>

  <div modal-actions class="actions">
    <evc-nav-button type="tertiary" class="cancel" (click)="reject.emit()">
      {{ "commonConfirmDialog.cancel" | translate }}
    </evc-nav-button>
    <evc-nav-button type="primary" variant="semi" (click)="confirm.emit()">
      {{ "commonConfirmDialog.confirmation" | translate }}
    </evc-nav-button>
  </div>
</evc-modal>
